import {GrmMediapipeFactory} from "./grm-mediapipe-factory";

class GrmMediapipe {
    #mainMediapipe;
    #subMediapipe;
    
    async getMainMediapipe() {
        if(!this.#mainMediapipe){
            this.#mainMediapipe = await this._createMediapipe();
        }
        return this.#mainMediapipe;
    }

    async getSubMediapipe() {
        if(!this.#subMediapipe){
            this.#subMediapipe = await this._createMediapipe();
        }
        return this.#subMediapipe;
    }
    
    async _createMediapipe() {
        const mediapipe = await GrmMediapipeFactory.factory({
                selfieSegmentationUrl: 'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/selfie_segmentation',
                // res: {
                //     sources: [
                //         'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/webgl-utils.js',
                //         'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/context-filter-pollyfill.js',
                //         'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/control_utils/control_utils.js',
                //         'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/drawing_utils/drawing_utils.js',
                //         'https://biz-cdn.gooroomee.com/files/web/common/lib/external/mediapipe/selfie_segmentation/selfie_segmentation.js'
                //     ],
                // }
            });
        return await mediapipe.init()
    }
}

export const RoomMediapipe = new GrmMediapipe()